import React, { useContext, useEffect, useState } from "react";
import Form from "../../components/form";
import api from "../../services/api";
import { mergeParams } from "../../helpers/helpers";
import AppContext from "../../pages/app/context";

import { Gauge, gaugeClasses } from "@mui/x-charts/Gauge";
import { Divider, Grid } from "@mui/material";
import { BarChart, barElementClasses } from "@mui/x-charts/BarChart";
import { axisClasses } from "@mui/x-charts/ChartsAxis";
import { TableContainer } from "@mui/material";
import { Table } from "@mui/material";
import { TableRow } from "@mui/material";
import { TableCell } from "@mui/material";
import { TableHead } from "@mui/material";
import { TableBody } from "@mui/material";

const dataAtual = new Date();
let dataAtualS = dataAtual.toISOString("pt-BR");
dataAtualS = dataAtualS.split("T")[0];

export default function DashboardTreinamentos({ location }) {
  const { notification } = useContext(AppContext);
  const [lista, setLista] = useState([]);
  const [listaRanking, setListaRanking] = useState([]);
  const [listaGrafico, setListaGrafico] = useState([]);

  const [filtros, setFiltros] = useState(
    mergeParams(
      {
        dataInicial: (dataAtual.getMonth() > 6 || dataAtual.getMonth() === 6 && dataAtual.getDate() > 15) ? 
          `${dataAtual.getFullYear()}-07-16` : 
          `${dataAtual.getFullYear()}-01-01`,
        dataFinal: dataAtualS,
      },
      location
    )
  );

  useEffect(() => {
    carregar();
  }, []);

  const carregar = (filtrosEnviar = filtros) => {
    setFiltros(filtrosEnviar);
    api
      .get("dashboard/carteiras", filtrosEnviar)
      .then((res) => {
        setLista(res);

        const ordemLista = res.sort((a, b) => {
          return (
            Number(b.pcTreinamentosFinalizados) -
            Number(a.pcTreinamentosFinalizados)
          );
        });

        setListaRanking(ordemLista);

        const formatoLista = [];

        ordemLista.forEach((item) => {
          formatoLista.push({
            data: [item.pcTreinamentosFinalizados],
            label: item.carteiraNome,
          });
        });
        setListaGrafico(formatoLista);
      })
      .catch((err) => {
        notification("error", "Erro ao carregar o relatório");
      });
  };

  const fFiltros = {
    title: "Período",
    form: {
      dataInicial: {
        label: "Data inicial",
        type: "date",
        space: 6,
        value: filtros.dataInicial,
      },
      dataFinal: {
        label: "Data final",
        type: "date",
        space: 6,
        value: filtros.dataFinal,
      },
    },

    submit: {
      label: "Buscar",
      action: carregar,
    },
  };

  return (
    <div>
      <Form formData={fFiltros} />
      {lista.map((item) => (
        <div style={{ background: "white", marginTop: 10 }}>
          <div style={{ padding: 10 }}>
            <h4>{item.carteiraNome}</h4>
          </div>

          <Grid container spacing={2}>
            <Grid item xs={6}>
              <div
                style={{
                  color: "black",
                  padding: 20,
                  margin: 10,
                  borderRadius: 10,
                  textAlign: "center",
                }}
              >
                {Number(item.pcTreinamentosMetaAtingida) >= 100 ? (
                  <h4>Meta atingida</h4>
                ) : (
                  <h4>Alcance da meta</h4>
                )}
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <h4>1%</h4>
                  </div>
                  <Gauge
                    width={300}
                    height={200}
                    value={item.pcTreinamentosMetaAtingida}
                    startAngle={-90}
                    endAngle={90}
                    valueMin={1}
                    valueMax={100}
                    sx={{
                      [`& .${gaugeClasses.valueText}`]: {
                        fontSize: 30,
                        // stroke: "white",
                        fill: "#f7af14",
                      },
                      [`& .${gaugeClasses.valueArc}`]: {
                        fill: "#f7af14",
                      },
                    }}
                    text={`${item.pcTreinamentosMetaAtingida}%`}
                  />

                  <div>
                    <h4>100%</h4>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid
              item
              xs={6}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <TableContainer>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableCell sx={{ fontWeight: "bold" }}>
                      Treinamentos da carteira
                    </TableCell>
                    <TableCell></TableCell>
                    <Divider />
                  </TableHead>
                  <TableBody>
                    <TableRow
                      hover
                      sx={{
                        cursor: "pointer",
                        background: ":hover: #F4F7FA",
                      }}
                    >
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Total
                      </TableCell>
                      <TableCell align="left">
                        {item.totalTreinamentos}
                      </TableCell>
                    </TableRow>
                    <TableRow
                      hover
                      sx={{
                        cursor: "pointer",
                        background: ":hover: #F4F7FA",
                      }}
                    >
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Iniciados
                      </TableCell>
                      <TableCell align="left">
                        {item.totalTreinamentosIniciados}
                      </TableCell>
                    </TableRow>
                    <TableRow
                      hover
                      sx={{
                        cursor: "pointer",
                        background: ":hover: #F4F7FA",
                      }}
                    >
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Finalizados
                      </TableCell>
                      <TableCell align="left">
                        {item.totalTreinamentosFinalizados}
                      </TableCell>
                    </TableRow>
                    <TableRow
                      hover
                      sx={{
                        cursor: "pointer",
                        background: ":hover: #F4F7FA",
                      }}
                    >
                      <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        Meta
                      </TableCell>
                      <TableCell align="left">
                        {item.totalTreinamentosMeta} ({item.pcTreinamentosMeta}% de {item.totalTreinamentos})
                      </TableCell>
                    </TableRow>
                    <TableRow
                      hover
                      sx={{
                        cursor: "pointer",
                        background: ":hover: #F4F7FA",
                      }}
                    >
                      {Number(item.pcTreinamentosMetaAtingida) >= 100 ? (
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Meta atingida
                        </TableCell>
                      ) : (
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Alcance da meta
                        </TableCell>
                      )}
                      {/* <TableCell align="center" sx={{ fontWeight: "bold" }}>
                        
                        Progresso para alcance da meta
                      </TableCell> */}
                      <TableCell align="left">
                        {item.pcTreinamentosMetaAtingida}% (
                        {item.totalTreinamentosFinalizados} de{" "}
                        {item.totalTreinamentosMeta})
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </div>
      ))}

      <div style={{ background: "white", marginTop: 10 }}>
        <Grid container>
          <Grid item xs={7}>
            <div style={{ padding: 10 }}>
              <h4>Treinamentos finalizados</h4>

              <div
                style={{
                  borderRadius: 10,
                  textAlign: "center",
                  color: "white",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <BarChart
                    sx={(theme) => ({
                      [`.${barElementClasses.root}`]: {
                        strokeWidth: 2,
                      },

                      [`.${axisClasses.root}`]: {
                        [`.${axisClasses.tick}, .${axisClasses.line}`]: {
                          // stroke: "white",
                          strokeWidth: 3,
                        },
                        [`.${axisClasses.tickLabel}`]: {
                          // fill: "white",
                        },
                      },
                    })}
                    series={listaGrafico}
                    width={900}
                    height={500}
                  />
                </div>
              </div>
            </div>
          </Grid>

          <Grid item xs={5}>
            <div style={{ padding: 10 }}>
              <h4>Ranking</h4>
            </div>

            <TableContainer>
              <Table aria-label="simple table">
                <TableHead>
                  <TableCell sx={{ fontWeight: "bold" }}>Posição</TableCell>
                  <TableCell>Carteira</TableCell>
                  <TableCell>Progresso para meta</TableCell>
                  <Divider />
                </TableHead>
                <TableBody>
                  {listaRanking.map((item, index) => (
                    <TableRow
                      hover
                      sx={{
                        cursor: "pointer",
                        background: ":hover: #F4F7FA",
                      }}
                    >
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="left">{item.carteiraNome}</TableCell>
                      <TableCell align="left">
                        {item.pcTreinamentosFinalizados}%
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
